module.exports = __webpack_public_path__ + "img/whittard_Vip.d8b06457.jpg";